import { environment } from 'src/environments/environment';
import { Component, Input, EventEmitter } from '@angular/core';
import Order from 'src/smoothr-web-app-core/models/Order';
import { ModalController } from '@ionic/angular';
import { Output } from '@angular/core';

@Component({
	selector: 'app-chip-table',
	templateUrl: './chip-table.component.html',
	styleUrls: ['./chip-table.component.scss'],
	standalone: false,
})
export class ChipTableComponent {
	@Input() order: Order;
	@Output() selectTableModal = new EventEmitter<void>();
	environment = environment;
	constructor(private modalCtrl: ModalController) {}
	async openSelectTable() {
		this.selectTableModal.emit();
	}
}
